import React from 'react';
import { Button, Dropdown, Menu } from 'semantic-ui-react';

const filtros = {
    todos: 'Todos',
    soloGastosNotariales: 'Solo gastos notariales',
    soloAbonosIniciales: 'Solo abonos iniciales',
};

export type Filtro = keyof typeof filtros;

interface Props {
    cantidadDeApoderados: number;
    cargando: boolean;
    filtro: Filtro;
    alCambiarFiltro(filtro: Filtro): void;
    alPresionarRecargar(): void;
}

const MenuTabla: React.FunctionComponent<Props> = props => {
    const { cantidadDeApoderados, cargando, filtro, alCambiarFiltro, alPresionarRecargar } = props;

    const textoFiltro = filtros[filtro];

    return (
        <Menu borderless size='large' attached='top' style={{ backgroundColor: '#f0f0ff' }}>
            <Menu.Item fitted='vertically'>
                <Button
                    style={{ height: '40px', width: '40px' }}
                    basic
                    icon='refresh'
                    loading={cargando}
                    onClick={alPresionarRecargar}
                />
            </Menu.Item>

            <Dropdown fitted='vertically' text={textoFiltro} item>
                <Dropdown.Menu>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltro('todos');
                        }}
                    >
                        {filtros.todos}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltro('soloGastosNotariales');
                        }}
                    >
                        {filtros.soloGastosNotariales}
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={() => {
                            alCambiarFiltro('soloAbonosIniciales');
                        }}
                    >
                        {filtros.soloAbonosIniciales}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            <Menu.Item position='right'>{cantidadDeApoderados} apoderados</Menu.Item>
        </Menu>
    );
};

export default MenuTabla;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Deudores/componentes/DeudoresCobrosCalculados/MenuTabla.tsx